import styled, { css } from 'styled-components'

export const MenuAccordionItem = styled.div<{ $isAccountPage?: boolean }>`
  padding: 0.8rem var(--mobile-menu-padding-x);
  position: relative;
  ${({ $isAccountPage }) =>
    $isAccountPage &&
    css`
      background-color: ${({ theme }) => theme.colors.grayscale.white};
    `};

  @media (min-width: 768px) {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
`
